export const endPoints = {
  BROKER: '/broker',
  BROKER_UPDATE: (id) => {
    return `/broker/update/${id}`
  },
  BROKER_ALL: '/broker/all',
  BROKER_COMPACT: '/broker/compact',
}
